import {
	IManageArticleTag,
	IManageArticleTagAction,
	IArticleTagManageDomainValue,
} from 'models/magazine/article/managearticletag';
import { IStore } from 'redux/IStore';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;
import { IArticleTagDomainValue } from 'models/magazine/article/articletagdomainvalue';
import { setArticleTags } from 'redux/modules/magazine/article/articletags';

/** Action Types */
export const REQUEST_START: string = 'managetag/REQUEST_START';
export const REQUEST_FAILURE: string = 'managetag/REQUEST_FAILURE';
export const TAG_ADDED_SUCCESS: string = 'managetag/TAG_ADDED_SUCCESS';
export const RESET_DATA: string = 'managetag/RESET_DATA';
export const GET_LANGUAGES_SUCCESS: string = 'managetag/GET_LANGUAGES_SUCCESS';

/** Initial State */
const initialState: IManageArticleTag = {
	isFetching: false,
	articleTag: {
		//key: null,
		value: null,
		languageKey: null,
		language: null,
	},
	tagAddedSuccess: false,
};

/** Reducer */
export function manageArticleTagReducer(state = initialState, action: IManageArticleTagAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case TAG_ADDED_SUCCESS:
			return Object.assign({}, state, {
				tagAddedSuccess: true,
				isFetching: false,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				articleTag: null,
				error: false,
				tagAddedSuccess: false,
			});

		default:
			return state;
	}
}

/** Action Creator - create */
export function createArticleTag(articleTag: IArticleTagManageDomainValue) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/CreateArticleTag',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(articleTag),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((newArticleTag) => {
						dispatch(addArticleTagInList(newArticleTag));
						dispatch(tagAddedSuccess());
						dispatch(resetData());
						dispatch(
							notifSend({
								message: i18n.t('Notification_Success_ArticleTag_Created'),
								kind: 'success',
								dismissAfter: 3000,
							}),
						);
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

export function addArticleTagInList(item: IArticleTagDomainValue) {
	return (dispatch, getState: () => IStore) => {
		const lang = getState().domainValues.languages.filter((x) => x.key === item.languageKey);
		if (!lang || lang.length === 0) {
			throw new Error('Language domain value not found');
		}
		item.language = lang[0].value;
		const articleTags: IArticleTagDomainValue[] = getState().articleTags.items;
		articleTags.push(item);

		dispatch(setArticleTags(articleTags));
	};
}

/** Action Creator */
export function requestStart(): IManageArticleTagAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function tagAddedSuccess(): IManageArticleTagAction {
	return {
		type: TAG_ADDED_SUCCESS,
	};
}

/** Action Creator */
export function requestFailure(message: any): IManageArticleTagAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function resetData(): IManageArticleTagAction {
	return {
		type: RESET_DATA,
	};
}
